import styles from '../../../../styles/Subscribe.module.scss';
import { Box } from "@mui/material";
import useScrollHandler from '../../hooks/useScrollHandler';
import StepItemContainer from './StepItemContainer';

const CARD_WIDTH = 70;
const CARD_MARGIN = 4;
const CARD_MAX_WIDTH = 250;

const MobileStepper = ({
  steps = [],
  activeStep = -1,
  onStepClick
}) => {
  const {
    scrollableContainerRef,
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd
  } = useScrollHandler(activeStep, CARD_WIDTH, CARD_MARGIN, CARD_MAX_WIDTH);

  if (steps.length === 0 || activeStep <= -1) {
    return null;
  }

  return (
    <Box
      sx={{ width: "100%", overflow: "hidden" }}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <div 
        className={styles.scrollableContainer}
        ref={scrollableContainerRef}
      >
        {steps.map((label, index) => (
          <StepItemContainer
            key={label}
            label={label}
            index={index}
            active={activeStep === index}
            completed={activeStep > index}
            cardWidth={CARD_WIDTH}
            cardMargin={CARD_MARGIN}
            cardMaxWidth={CARD_MAX_WIDTH}
            onClick={() => onStepClick(index)}
          />
        ))}
      </div>
    </Box>
  )
}

export default MobileStepper;